export default "__VITE_PUBLIC_ASSET__d971508d__"